import React from 'react';
import columns from '../../../../../react-table/helpers/columns';

export function getPropsForHighlight(index) {
  return ((state, rowInfo) => {
    let className = '';
    if (rowInfo) {
      if (rowInfo.original.cells[index].highlightColor === 'green') {
        className = 'bg-green-2 text-green-2';
      } else if (rowInfo.original.cells[index].highlightColor === 'orange') {
        className = 'bg-orange-1 text-orange-1';
      } else if (rowInfo.original.cells[index].highlightColor === 'red') {
        className = 'bg-red-2 text-red-2';
      }
    }
    return { className };
  });
}

export function getValue(rawValue) {
  if (rawValue === '__;20') return '2.0';
  if (rawValue === '21;__') return '2.1';
  if (rawValue === '21;20') return '2.0;2.1';
  return '';
}

export function getColumns(matrixRow, data) {
  const { TextColumn } = columns(data);
  return matrixRow.map((matrix, index) => ({
    Header: () => (
      <div />
    ),
    metadataForDownload: {
      firstLine: matrix.label,
    },
    columns: [
      new TextColumn(`${matrix.label}`, row => getValue(row.cells[index].value))
        .withId(`ems${index}`).withGetProps(getPropsForHighlight(index)),
    ],
  }));
}

export default (data, metadata) => {
  if (!metadata || !metadata.columns) {
    return [];
  }
  const { TextColumn } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin', 'countryFrom'),
      ],
    },
    ...getColumns(metadata.columns.slice(1), data),
  ];
};
